@use "@design/design-tokens/typography/typography" as *;
@use "@design/design-tokens/border-radius/border-radius" as *;
@use "@design/components/custom-scroll/custom-scroll" as *;

.checkboxTooltip {
  padding: 4px 8px;
}

.emptyRoot {
  width: 100%;
  max-width: calc(var(--content-max-width) - 40px);
  padding: 80px 20px;
  margin: 0 auto;
}

.root {
  @include custom-scroll-minimal;
  display: flex;
  flex-direction: column;
  max-width: var(--content-max-width);
  gap: 20px;
  padding: 20px 20px 80px 0;
  margin: 0 auto;

  > table {
    [data-checkmark] {
      height: 20px;
      width: 20px;
      margin: 0;
    }
  }
}

.upcomingItem {
  flex: 1;
  text-align: center;
}

.upcomingRoot {
  @include border-radius-r2;
  border: 1px solid var(--border-soft);
  background: var(--surface-default);
  display: flex;
  gap: 8px;
  padding: 12px;

  .upcomingItem {
    border-right: 1px solid var(--border-soft);

    &:last-child {
      border-right: none;
    }
  }
}

.upcomingTitle {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  display: block;
  line-height: 20px;
}

.upcomingValue {
  @include typography-v2-title-sm;
  display: block;
  line-height: 24px;
}

.styledTableHeader {
  &[data-table-header] {
    z-index: var(--z-index-header-cell);
    font-weight: 500;
    background-color: var(--background-default);
    position: sticky;
    top: 0;
  }
}

.headerGroupRow {
  &[data-table-header] {
    border-bottom: none;
  }
}

.headerHighlighted {
  &[data-table-header] {
    background-color: var(--text-inverse);
  }
}

.headerPinned {
  position: sticky;
  z-index: calc(var(--z-index-header-cell) + 1);
  left: var(--header-left);
  right: var(--header-right);
  top: 0;
}

.headerLastPinned {
  border-right: 1px solid var(--border-default);
}

.headerSortable {
  &:hover {
    background-color: var(--surface-hover);
    cursor: pointer;
  }
}

.headerLastGroup {
  border-bottom: 1px solid var(--border-default);
}

.tableHeaderContent {
  display: flex;
  width: 100%;
  justify-content: left;
  gap: 24px;
}

.earningsCell {
  width: 66px;
  display: flex;
  justify-content: left;
}

.periodCell {
  font-family: var(--font-nort);
}

.periodValue {
  @include typography-v2-body-sm;
}

.periodDate {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}

.filterOptionsWrapper {
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
}

.styledToggle {
  background-color: var(--surface-default);
  padding: 8px;
  @include border-radius-r2;
}

.wrapperCheckbox {
  height: 20px;
  width: 20px;

  svg {
    width: 20px;
    height: 20px;
  }
}

.styledCheckBox {
  [data-checkmark] {
    margin-top: 2px;
  }
}

.matchingFilters {
  &[data-checkbox-wrapper] [data-checkmark] {
    border-color: var(--border-primary);

    &:hover {
      border-color: var(--border-primary);
    }
  }
}

.manualUpdated {
  &[data-checkbox-wrapper] [data-checkmark] {
    background-color: var(--icon-soft);
    border-color: var(--border-default);

    &:hover {
      border-color: var(--border-default);
    }
  }
}

.matchingFilterLabel {
  @include typography-v2-body-sm;
  color: var(--text-default);
}
